import FullScreen from "src/atoms/FullScreen";
import Flow from "src/components/Flow";
import { steps } from "./steps";
import { useEffect } from "react";
import setWizardWindowSize from "src/utils/setWizardWindowSize";
import { useLocation, useNavigate } from "react-router-dom";

export default function OnboardingView() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setWizardWindowSize();
  }, []);

  return (
    <FullScreen>
      <Flow
        steps={steps}
        initialStep={location.state?.showLastStep ? "second" : "first"}
        flowState={{
          finish: () => {
            navigate("/welcome");
          }
        }}
      />
    </FullScreen>
  );
}
